import { env } from '@c2fo/common-config';

export const config = {
  ADMIN_API_URL: env.getString('ADMIN_API_URL') || 'https://fss-gateway.c2fo.com',
  ADMIN_LOCAL_API_URL: env.getString('ADMIN_LOCAL_API_URL') || 'http://localhost:3000',
  AUTH_SERVICE_URL: env.getString('AUTH_SERVICE_URL') || 'https://fss-gateway.c2fo.com/api/auth',
  GATEWAY_URL: env.getString('GATEWAY_URL') || 'https://fss-gateway.c2fo.com',
  INSIGHTS_AGENT_URL: env.getString('INSIGHTS_AGENT_URL') || 'http://localhost:8000',
  INSIGHTS_FEEDBACK_ENABLED: env.getBoolean('INSIGHTS_FEEDBACK_ENABLED') || false,
  NEW_ADMIN_UI_URL: env.getString('NEW_ADMIN_UI_URL') || 'http://localhost:8800',
  RAG_API_URL: env.getString('RAG_API_URL') || 'https://rs-rag-dev.c2fo.io',
  RAG_TABLE_INFO_COLLECTION_ID: env.getString('RAG_TABLE_INFO_COLLECTION_ID') || '7684cada-fccf-4852-b3f0-609fb48564c6',
  USE_DIRECT_ADMIN_API: env.getBoolean('USE_DIRECT_ADMIN_API') || false,
  USER_API_URL: env.getString('USER_API_URL') || 'https://fss-gateway.c2fo.com',
  USER_LOCAL_API_URL: env.getString('USER_LOCAL_API_URL') || 'http://localhost:3001',
};
